<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.employee.editProfessor')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>

                <!-- <b-alert v-model="disableEditForm" variant="info">{{disableEditFormMessage}}</b-alert> -->
                <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>


                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">

                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.employee.editProfessor')}}</div>

                        <div class="text-right">
                            <button class="btn btn-primary" @click="saveProfessor()"
                                :disabled="disableEditForm || readonly">{{$t('button.update')}}</button>
                            <button class="btn btn-info" @click="saveProfessor(true)"
                                :disabled="disableEditForm || readonly">{{$t('button.updateClose')}}</button>
                        </div>

                    </div>

                    <div class="card-body">

                        <b-tabs content-class="mt-3">
                            <b-tab :title="$t('form.employee.tabPersonal')" active>
                                <div class="row">
                                    <div class="col-md-3">

                                         <div class="form-group">
                                            <h3>{{$t('form.employee.photo')}}</h3>
                                            <input type="file"  ref="profile_image"  style="display:none" @input="showSelectedImage" accept="image/*">
                                            <img  :src="image" @click="$refs.profile_image.click()"
                                            class="img-responsive" style="cursor:pointer; max-width:200px; max-height:200px">
                                        </div>

                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="Title:">{{$t('form.employee.title')}}</label>
                                            <v-select :options="titles" v-model="professor.Title"
                                                :reduce="titles => titles" :key="professor.Title">
                                            </v-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="FirstName:">{{$t('form.employee.firstName')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" id="FirstNameField" class="form-control"
                                                :class="{ 'is-invalid': $v.professor.FirstName.$error }"
                                                v-model.trim="$v.professor.FirstName.$model">
                                            <div class="invalid-feedback" v-if="!$v.professor.FirstName.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professor.FirstName.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.FirstName.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="LastName">{{$t('form.employee.lastName')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" id="LastNameField" class="form-control"
                                                v-model.trim="$v.professor.LastName.$model"
                                                :class="{ 'is-invalid': $v.professor.LastName.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professor.LastName.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professor.LastName.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.LastName.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="BirthDate:">{{$t('form.employee.birthDate')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <input id="BirthDate" name="BirthDate" v-model="professor.BirthDate"
                                                type="date" class="form-control"
                                                :class="{ 'is-invalid': $v.professor.BirthDate.$error }"
                                                v-model.trim="$v.professor.BirthDate.$model">
                                            <div class="invalid-feedback" v-if="!$v.professor.BirthDate.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="BirthPlace:">{{$t('form.employee.birthPlace')}}</label>
                                            <input type="text" id="BirthPlaceField"
                                                v-model.trim="$v.professor.BirthPlace.$model" class="form-control"
                                                :class="{ 'is-invalid': $v.professor.BirthPlace.$error }">

                                            <div class="invalid-feedback" v-if="!$v.professor.BirthPlace.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.BirthPlace.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="BirthCountry">{{$t('form.employee.birthCountry')}}</label>
                                            <v-select label="printable_name" :options="countries"
                                                v-model="professor.BirthCountry"
                                                :reduce="countries => countries.printable_name"
                                                :key="professor.BirthCountry">
                                            </v-select>
                                        </div>

                                        <div class="form-group">
                                            <label>{{$t('form.employee.department')}}</label>
                                            <v-select :options="departments" v-model="professor.Department"
                                                :reduce="departments => departments" :key="professor.Department">
                                            </v-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="Position">{{$t('form.employee.position')}}</label>
                                            <v-select :options="positions" v-model="professor.Position"
                                                :reduce="positions => positions" :key="professor.Position">
                                            </v-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="StreetAddress">
                                                {{$t('form.employee.streetAddress')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professor.StreetAddress.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professor.StreetAddress.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professor.StreetAddress.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="City:">{{$t('form.employee.city')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" id="CityField" v-model.trim="$v.professor.City.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professor.City.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professor.City.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.professor.City.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.City.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="Zip:">{{$t('form.employee.zip')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professor.Zip.$model"
                                                class="form-control" :class="{ 'is-invalid': $v.professor.Zip.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professor.Zip.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.professor.Zip.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.Zip.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="Country">{{$t('form.employee.country')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <v-select label="printable_name" :options="countries"
                                                v-model.trim="$v.professor.Country.$model"
                                                :reduce="countries => countries.printable_name"
                                                :key="professor.Country">
                                            </v-select>

                                            <div class="invalid-feedback custom-validate"
                                                v-if="invalidProfessorCountry">
                                                {{$t('form.validation.required')}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="PhoneField">{{$t('form.employee.phone')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <div class="d-flex align-items-center">
                                                <input type="text" id="PhoneField"
                                                    v-model.trim="$v.professor.Phone.$model" class="form-control"
                                                    :class="{ 'is-invalid': $v.professor.Phone.$error }">
                                                <a :href="`tel:${professor.Phone}`"
                                                    class="btn btn-default text-nowrap">{{$t('button.call')}}</a>
                                            </div>
                                            <div class="invalid-feedback d-block" v-if="!$v.professor.Phone.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback d-block" v-if="!$v.professor.Phone.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.Phone.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="MobileField">
                                                {{$t('form.employee.mobile')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <div class="d-flex align-items-center">
                                                <input type="text" id="MobileField"
                                                    v-model.trim="$v.professor.Mobile.$model" class="form-control"
                                                    :class="{ 'is-invalid': $v.professor.Mobile.$error }">
                                                <a :href="`tel:${professor.Mobile}`"
                                                    class="btn btn-default text-nowrap">{{$t('button.call')}}</a>
                                            </div>
                                            <div class="invalid-feedback d-block" v-if="!$v.professor.Mobile.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback d-block" v-if="!$v.professor.Mobile.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.Mobile.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="Fax">{{$t('form.employee.fax')}}</label>
                                            <input id="Fax" name="Fax" v-model="professor.Fax" type="text"
                                                class="form-control">
                                        </div>

                                        <div class="form-group">
                                            <label for="EmailField">
                                                {{$t('form.employee.email')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <div class="d-flex align-items-center">
                                                <input type="email" id="EmailField"
                                                    v-model.trim="$v.professor.Email.$model" class="form-control"
                                                    :class="{ 'is-invalid': $v.professor.Email.$error }">
                                                <a :href="`mailto:${professor.Email}`"
                                                    class="btn btn-default text-nowrap">{{$t('button.email')}}</a>
                                            </div>
                                            <div class="invalid-feedback d-block" v-if="!$v.professor.Email.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback d-block" v-if="!$v.professor.Email.email">
                                                {{$t('form.validation.validEmail')}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="Email2Field">{{$t('form.employee.email2')}}</label>
                                            <div class="d-flex">
                                                <input id="Email2Field" name="Email2" v-model="professor.Email2"
                                                    type="text" class="form-control">
                                                <a :href="`mailto:${professor.Email2}`"
                                                    class="btn btn-default text-nowrap">{{$t('button.email')}}</a>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="Email3Field">{{$t('form.employee.email3')}}</label>
                                            <div class="d-flex">
                                                <input id="Email3Field" name="Email3" v-model="professor.Email3"
                                                    type="text" class="form-control">
                                                <a :href="`mailto:${professor.Email3}`"
                                                    class="btn btn-default text-nowrap">{{$t('button.email')}}</a>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="WebAddress">{{$t('form.employee.webAddress')}}</label>
                                            <input id="WebAddress" name="WebAddress" v-model="professor.WebAddress"
                                                type="text" class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId20">
                                            <span id="errId20" class="error"></span>
                                        </div>

                                        <div class="form-group">
                                            <label for="Notes:">{{$t('form.employee.notes')}}</label>
                                            <textarea id="Notes:" name="Notes" v-model="professor.Notes" rows="5"
                                                class="form-control" data-role="textarea"
                                                data-parsley-errors-container="#errId21"></textarea>
                                            <span id="errId21" class="error"></span>
                                        </div>
                                    </div>


                                    <div class="col-3">
                                          <div class="shadow mb-4 p-3">
                                            <h6>
                                                <u>
                                                    <b>{{$t('form.employee.mailAddress')}}</b>
                                                </u>
                                            </h6>
                                            <div class="form-group">
                                                <label>
                                                    <input type="radio" v-model="professor.MailAddress" value="1">
                                                    {{$t('form.employee.mailAddressOption1')}}
                                                </label>
                                            </div>
                                            <div class="form-group">
                                                <label>
                                                    <input type="radio" v-model="professor.MailAddress" value="2">
                                                    {{$t('form.employee.mailAddressOption2')}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.employee.tabBusiness')">
                                <div class="row">

                                    <div class="col-sm-8"  v-if="parseInt(professor.MailAddress) === 2">
                                        <div class="form-group">
                                            <label for="CompanyName:">
                                                {{$t('form.employee.companyName')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input id="CompanyName" type="text"
                                                v-model.trim="$v.professorBusiness.CompanyName.$model"
                                                name="CompanyName" class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.CompanyName.$error }">
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.CompanyName.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.CompanyName.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.CompanyName.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessDepartment">
                                                {{$t('form.employee.department')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" id="BusinessDepartment"
                                                v-model.trim="$v.professorBusiness.Department.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Department.$error }">
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.Department.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.Department.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.Department.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessPosition:">
                                                {{$t('form.employee.position')}}
                                                <span class="req text-danger">*</span>
                                            </label>

                                            <input id="BusinessPosition:" name="BusinessPosition"
                                                v-model.trim="$v.professorBusiness.Position.$model" class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Position.$error }">
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.Position.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.Position.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.Position.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="StreetAddress:">
                                                {{$t('form.employee.streetAddress')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professorBusiness.StreetAddress.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.StreetAddress.$error }">
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.StreetAddress.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="City:">
                                                {{$t('form.employee.city')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" id="City" v-model.trim="$v.professorBusiness.City.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.City.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.City.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.City.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.City.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class for="Zip:">
                                                {{$t('form.employee.zip')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professorBusiness.Zip.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Zip.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Zip.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Zip.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.Zip.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Country:">
                                                {{$t('form.employee.country')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <v-select label="printable_name" :options="countries"
                                                v-model.trim="$v.professorBusiness.Country.$model"
                                                :reduce="countries => countries.printable_name"
                                                class="BussinessCountry">
                                            </v-select>

                                            <div class="invalid-feedback custom-validate"
                                                v-if="invalidBussinessCountry">
                                                {{$t('form.validation.required')}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Phone:">
                                                {{$t('form.employee.phone')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professorBusiness.Phone.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Phone.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Phone.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Phone.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.Phone.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Mobile:">
                                                {{$t('form.employee.mobile')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professorBusiness.Mobile.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Mobile.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Mobile.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Mobile.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.Mobile.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Fax:">{{$t('form.employee.fax')}}</label>

                                            <input id="Fax:" name="Fax" v-model="professorBusiness.Fax" type="text"
                                                class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId31">
                                            <span id="errId31" class="error"></span>
                                        </div>
                                        <div class="form-group">
                                            <label>
                                                {{$t('form.employee.email')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="email" v-model.trim="$v.professorBusiness.Email.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Email.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Email.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Email.email">
                                                {{$t('form.validation.validEmail')}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="BussinessWebAddress:">
                                                {{$t('form.employee.webAddress')}}
                                            </label>

                                            <input id="BussinessWebAddress:" name="BussinessWebAddress"
                                                v-model="professorBusiness.WebAddress" type="text" class="form-control"
                                                data-role="text" data-parsley-errors-container="#errId33">
                                        </div>
                                        <div class="form-group">
                                            <h5>
                                                <b>
                                                    <u>{{$t('form.employee.contactPerson')}}</u>
                                                </b>
                                            </h5>
                                            <p id="field89" data-default-label="Header" data-default-is-header="true"
                                                data-control-type="header"></p>
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonTitle:">{{$t('form.employee.title')}}</label>
                                            <v-select :options="titles" v-model="professorBusiness.ContactPersonTitle"
                                                :reduce="titles => titles">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class for="FirstName:">
                                                {{$t('form.employee.firstName')}}
                                            </label>

                                            <input type="text" id="ContactPersonFirstNameField"
                                                v-model.trim="$v.professorBusiness.ContactPersonFirstName.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.ContactPersonFirstName.$error }">

                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.ContactPersonFirstName.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.ContactPersonFirstName.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="LastName:">
                                                {{$t('form.employee.lastName')}}
                                            </label>

                                            <input type="text" id="ContactPersonLastNameField"
                                                v-model.trim="$v.professorBusiness.ContactPersonLastName.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.ContactPersonLastName.$error }">

                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.ContactPersonLastName.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.ContactPersonLastName.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonDepartment:">
                                                {{$t('form.employee.department')}}
                                            </label>

                                            <input type="text" id="ContactPersonDepartment"
                                                v-model.trim="$v.professorBusiness.ContactPersonDepartment.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.ContactPersonDepartment.$error }">

                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.ContactPersonDepartment.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.ContactPersonDepartment.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-sm-8"  v-else>
                                        <div class="form-group">
                                            <label for="CompanyName:">
                                                {{$t('form.employee.companyName')}}
                                            </label>
                                            <input id="CompanyName" type="text"
                                                v-model.trim="professorBusiness.CompanyName"
                                                name="CompanyName" class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessDepartment">
                                                {{$t('form.employee.department')}}
                                            </label>
                                            <input type="text" id="BusinessDepartment"
                                                v-model.trim="professorBusiness.Department"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessPosition:">
                                                {{$t('form.employee.position')}}
                                            </label>

                                            <input id="BusinessPosition:" name="BusinessPosition"
                                                v-model.trim="professorBusiness.Position" class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="StreetAddress:">
                                                {{$t('form.employee.streetAddress')}}
                                            </label>
                                            <input type="text" v-model.trim="professorBusiness.StreetAddress"
                                                class="form-control">
                                        </div>

                                        <div class="form-group">
                                            <label for="City:">
                                                {{$t('form.employee.city')}}
                                            </label>
                                            <input type="text" id="City" v-model.trim="professorBusiness.City"
                                                class="form-control">
                                        </div>

                                        <div class="form-group">
                                            <label class for="Zip:">
                                                {{$t('form.employee.zip')}}
                                            </label>
                                            <input type="text" v-model.trim="professorBusiness.Zip"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="Country:">
                                                {{$t('form.employee.country')}}
                                            </label>
                                            <v-select label="printable_name" :options="countries"
                                                v-model.trim="professorBusiness.Country"
                                                :reduce="countries => countries.printable_name"
                                                class="BussinessCountry">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Phone:">
                                                {{$t('form.employee.phone')}}
                                            </label>
                                            <input type="text" v-model.trim="professorBusiness.Phone"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="Mobile:">
                                                {{$t('form.employee.mobile')}}
                                            </label>
                                            <input type="text" v-model.trim="professorBusiness.Mobile"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="Fax:">{{$t('form.employee.fax')}}</label>

                                            <input id="Fax:" name="Fax" v-model="professorBusiness.Fax" type="text"
                                                class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId31">
                                            <span id="errId31" class="error"></span>
                                        </div>
                                        <div class="form-group">
                                            <label>
                                                {{$t('form.employee.email')}}
                                            </label>
                                            <input type="email" v-model.trim="professorBusiness.Email"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="BussinessWebAddress:">
                                                {{$t('form.employee.webAddress')}}
                                            </label>

                                            <input id="BussinessWebAddress:" name="BussinessWebAddress"
                                                v-model="professorBusiness.WebAddress" type="text" class="form-control"
                                                data-role="text" data-parsley-errors-container="#errId33">
                                        </div>
                                        <div class="form-group">
                                            <h5>
                                                <b>
                                                    <u>{{$t('form.employee.contactPerson')}}</u>
                                                </b>
                                            </h5>
                                            <p id="field89" data-default-label="Header" data-default-is-header="true"
                                                data-control-type="header"></p>
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonTitle:">{{$t('form.employee.title')}}</label>
                                            <v-select :options="titles" v-model="professorBusiness.ContactPersonTitle"
                                                :reduce="titles => titles">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class for="FirstName:">
                                                {{$t('form.employee.firstName')}}
                                            </label>

                                            <input type="text" id="ContactPersonFirstNameField"
                                                v-model.trim="professorBusiness.ContactPersonFirstName"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="LastName:">
                                                {{$t('form.employee.lastName')}}
                                            </label>

                                            <input type="text" id="ContactPersonLastNameField"
                                                v-model.trim="professorBusiness.ContactPersonLastName"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonDepartment:">
                                                {{$t('form.employee.department')}}
                                            </label>

                                            <input type="text" id="ContactPersonDepartment"
                                                v-model.trim="professorBusiness.ContactPersonDepartment"
                                                class="form-control">
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class for="Notes:">{{$t('form.employee.notes')}}</label>

                                            <textarea id="Notes:" name="Notes" v-model="professorBusiness.Notes"
                                                rows="15" class="form-control" data-role="textarea"
                                                data-parsley-errors-container="#errId39"></textarea>
                                            <span id="errId39" class="error"></span>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.employee.tabRemarks')">
                                <div class="form-group">
                                    <label class for="Remarks:">{{$t('form.employee.remarks')}}</label>
                                    <textarea id="Remarks:" name="Remarks" v-model="professor.Remarks" rows="15"
                                        class="form-control" data-role="textarea"
                                        data-parsley-errors-container="#errId40"></textarea>
                                    <span id="errId40" class="error"></span>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.employee.tabCourses')">
                                <div class="form-group">
                                    <div class="p-0">
                                        <table class="table table-bordered" style="min-height:200px;">
                                            <thead>
                                                <tr>
                                                    <th style="min-width:200px">{{$t('form.employee.program')}}<span
                                                            v-if="lectures.length > 0" class="text-danger">*</span>
                                                    </th>
                                                    <th style="min-width:200px">{{$t('form.employee.course')}}<span
                                                            v-if="lectures.length > 0" class="text-danger">*</span>
                                                    </th>
                                                    <th>{{$t('form.employee.academicYear')}}<span
                                                            v-if="lectures.length > 0" class="text-danger">*</span>
                                                    </th>
                                                    <th>{{$t('form.employee.term')}}<span v-if="lectures.length > 0"
                                                            class="text-danger">*</span>
                                                    </th>
                                                    <th class="text-right" v-if="!readonly">
                                                        <b-button @click="addLecture()" :title="$t('button.new')">
                                                            <i class="fas fa-plus-circle"></i></b-button>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(lecture, index) in lectures" :key="index">
                                                    <td>
                                                        <v-select @input="selectProgram(index)" label="FullTitle"
                                                            :options="programs" v-model="lecture.ProgramID"
                                                            :reduce="program => program.ID">
                                                        </v-select>
                                                    </td>
                                                    <td>
                                                        <v-select label="FullTitle" :options="courses[index]"
                                                            v-model="lecture.CourseID" :reduce="course => course.ID">
                                                        </v-select>
                                                    </td>
                                                    <td>
                                                        <select v-model="lecture.AcademicYear" class="form-control">
                                                            <option v-for="(academicYear , index) in academicYearList"
                                                                :key="index" :value="academicYear">
                                                                {{academicYear}}</option>
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input type="number" class="form-control"
                                                            v-model="lecture.Term">
                                                    </td>
                                                    <td class="text-right" v-if="!readonly">
                                                        <a class="btn btn-danger text-white btn-sm"
                                                            @click="removeLecture(index)">
                                                            <i class="fa fa-times" aria-hidden="true"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.employee.tabContracts')" v-if="isHR || isAdmin">
                             <Contracts :readonly="readonly" :removeContract="removeContract" :downloadContract="downloadContract" :contractDropzone="contractDropzone" :contractUploaded="contractUploaded" :uploadFileError="uploadFileError" :contracts="contracts" :getAttachmentFileName="getAttachmentFileName"/>
                            </b-tab>

                            <b-tab :title="$t('form.student.tabAttachment')">
                               <attachments :readonly="readonly" :isLoading="isLoading" :attachments="attachments" :downloadAttachment="downloadAttachment" :removeAttachment="removeAttachment" :attachmentUploaded="attachmentUploaded" :uploadFileError="uploadFileError" :attachmentDropzone="attachmentDropzone" :getAttachmentFileName="getAttachmentFileName"/>
                            </b-tab>

                            <b-tab :title="$t('form.employee.tabAudit')">
                                <b-table id="my-table" :items="audits" :per-page="perPageAudits" sort-by="date"
                                    :sort-desc="true" :current-page="currentPage" :fields="fields" small hover bordered
                                    responsive>
                                </b-table>

                                <b-pagination v-if="totalAudits" v-model="currentPage" :total-rows="totalAudits"
                                    :per-page="perPageAudits" aria-controls="my-table" align="center" pills>
                                </b-pagination>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import vue2Dropzone from "vue2-dropzone";

    import {
        required,
        minLength,
        maxLength,
        email
    } from "vuelidate/lib/validators";
    import Attachments from './components/Attachments';
    import Contracts from './components/Contracts';

    export default {
        props: ['permissions', 'editFormInterval', 'datetimeFormat', 'user'],

        components: {
            vueDropzone: vue2Dropzone, Attachments, Contracts
        },

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',
                disableEditForm: false,
                disableEditFormMessage: '',


                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,


                isLoading: false,
                fullPage: true,

                interval: '',
                requestSource: '',
                blockRemoval: true,
                invalidProfessorCountry: false,
                invalidBussinessCountry: false,
                closing: true,

                image: `/images/default.jpg`,

                pagination: {
                    current_page: 1
                },

                // audits custom pagination
                currentPage: 1,
                perPageAudits: 5,
                fields: ['field', 'oldValue', 'newValue', 'userName', 'createdAt'],

                profileDropzone: {
                    url: "/api/professors/profile-image",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150,
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    maxFiles: 1
                },

                contractDropzone: {
                    url: "/api/professors/contracts/add",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150
                },

                attachmentDropzone: {
                    url: "/api/professors/attachments/add",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150
                },

                titles: [],
                departments: [],
                positions: [],
                countries: [],

                courses: [],
                programs: [],

                contracts: [],
                lectures: [],
                attachments: [],
                audits: [],

                professor: {
                    FirstName: '',
                    LastName: '',
                    Title: '',
                    BirthDate: null,
                    BirthPlace: '',
                    BirthCountry: '',
                    StreetAddress: '',
                    City: '',
                    Zip: '',
                    Country: '',
                    Phone: '',
                    Mobile: '',
                    Fax: '',
                    Email: '',
                    Email2: '',
                    Email3: '',
                    WebAddress: '',
                    Photo: '',
                    Remarks: '',
                    Notes: '',
                    Department: '',
                    Position: '',
                    MailAddress: 1,
                    SendEmail: null
                },

                professorBusiness: {
                    CompanyName: '',
                    Department: '',
                    Position: '',
                    StreetAddress: '',
                    City: '',
                    Zip: '',
                    Country: '',
                    Phone: '',
                    Mobile: '',
                    Fax: '',
                    Email: '',
                    WebAddress: '',
                    ContactPersonTitle: '',
                    ContactPersonFirstName: '',
                    ContactPersonLastName: '',
                    ContactPersonDepartment: '',
                    Notes: ''
                }
            }
        },

        validations: {
            professor: {
                FirstName: {
                    required,
                    maxLength: maxLength(100)
                },
                LastName: {
                    required,
                    maxLength: maxLength(100)
                },
                BirthPlace: {
                    maxLength: maxLength(100)
                },
                BirthDate: {
                    required
                },
                StreetAddress: {
                    required
                },
                City: {
                    required,
                    maxLength: maxLength(100)
                },
                Country: {
                    required
                },
                Zip: {
                    required,
                    maxLength: maxLength(50)
                },
                Phone: {
                    required,
                    maxLength: maxLength(100)
                },
                Mobile: {
                    required,
                    maxLength: maxLength(100)
                },
                Email: {
                    required,
                    email
                }
            },
              professorBusiness:{
                CompanyName: {
                    required,
                    maxLength: maxLength(100)
                },
                Department: {
                    required,
                    maxLength: maxLength(100)
                },
                Position: {
                    required,
                    maxLength: maxLength(100)
                },
                StreetAddress: {
                    required,
                    maxLength: maxLength(255)
                },
                City: {
                    required,
                    maxLength: maxLength(100)
                },
                Country: {
                    required
                },
                Zip: {
                    required,
                    maxLength: maxLength(50)
                },
                Phone: {
                    required,
                    maxLength: maxLength(100)
                },
                Mobile: {
                    required,
                    maxLength: maxLength(100)
                },
                Email: {
                    required,
                    email
                },
                ContactPersonFirstName: {
                    maxLength: maxLength(100)
                },
                ContactPersonLastName: {
                    maxLength: maxLength(100)
                },
                ContactPersonDepartment: {
                    maxLength: maxLength(100)
                }
            }
        },

        computed: {
            academicYearList() {
                let year = moment().format('YYYY');
                let yearlist = [];

                for (let i = 0; i < 18; i++, year--) {
                    yearlist[i] = year;
                }

                return yearlist;
            },

            totalAudits() {
                return this.audits.length
            },

            isAdmin() {
                if (this.user.roles) {
                    let found = this.user.roles.find(role => role.slug == 'admin');

                    if (found) return true;
                }

                return false;
            },

            isHR() {
                if (this.user.roles) {
                    let found = this.user.roles.find(role => role.slug == 'hr');

                    if (found) return true;
                }

                return false;
            },

            readonly() {
                return !this.permissions.editEmployeeProfessors;
            }
        },

        watch: {
            professor: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },

            professorBusiness: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },

            lectures: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },

            contracts: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },

            attachments: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            }

        },

        async mounted() {
            if (!this.permissions.viewEmployeeProfessors) {
                this.$router.push("/");
                return;

            }

            if (this.permissions.editEmployeeProfessors) {
                this.checkForEdit();
                let self = this;

                this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);
            }

            await this.getInitialData();
            await this.getProfessor();
        },

        methods: {

            async createToken(type = null) {
                let response = await axios.post('/api/api-tokens', {
                    type: `professor-${type}`,
                });
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async downloadAttachment(file , isDownload = false) {

                let token = await this.createToken('attachment');
                if (token == '') return;

                // Encode the file name to handle special characters
                let encodedFileName = encodeURIComponent(file.Name);
                let encodedFilePath = encodeURIComponent(file.File);

                window.open(`/professors/attachments/${encodedFileName}?${file.ID}&file=${encodedFilePath}&download=${isDownload}&token=${token}`, '_blank');
            },

            async downloadContract(file , isDownload = false) {
                let token = await this.createToken('contract');

                if (token == '') return;

                // Encode the file name to handle special characters
                let encodedFileName = encodeURIComponent(file.Name);
                let encodedFilePath = encodeURIComponent(file.File);

                window.open(`/professors/contracts/${encodedFileName}?${file.ID}&file=${encodedFilePath}&download=${isDownload}&token=${token}`, '_blank');

            },

            async getInitialData() {
                await axios
                    .get("/api/professors/initial-data")
                    .then(response => {

                        this.titles = response.data.titles;
                        this.countries = response.data.countries;

                        this.departments = response.data.departments;
                        this.positions = response.data.positions;

                        this.programs = response.data.programs;
                        this.programs.map(p => p.FullTitle = this.$options.filters.program(p));

                        this.perPageAudits = response.data.auditsPaginate;
                    })
                    .catch(error => {
                        console.log('error');
                    });
            },

          // show selecete image
            showSelectedImage(){

                 let input = this.$refs.profile_image
                let file = input.files
                if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.image = e.target.result
                }
                reader.readAsDataURL(file[0])
                this.$emit('input', file[0])
                }

                let fd = new FormData();
                fd.append('file',file[0]);
                this.isLoading = true;
                axios.post('/api/professors/profile-image',fd).then(resp=>{
                    this.professor.Photo = resp.data.filename;
                    this.isLoading = false;
                }).catch(error=>{
                    this.isLoading = false;
                    console.log('file not found');
                });
            },

            /**
             * Format Date
             */
            formatDate(format = "YYYY-MM-DD", date) {
                if (date) {
                    return moment(date).format(format);
                }
                return null;
            },

            getAttachmentFileName(file) {
                var file = file;
                if (typeof file === "string") {
                    return file.substring(file.lastIndexOf("/") + 1);
                } else {
                    return file;
                }
            },

            /**
             * Uploaded Contract Auto-save
             */
            contractUploaded(file, data) {
                this.loading = false;
                axios
                    .post("/api/professors/contract/file/save", {
                        Name: data.filename,
                        File: `${data.id}/${data.filename}`,
                        ProfessorID: this.professor.ID,
                        Description: "",
                        AttachmentDate: this.formatDate(),
                        UploadTimestamp:calculateTimeAsPerTimeZone('+2')
                    })
                    .then(response => {
                        if (response.data)
                        {
                            this.contracts.push({...response.data?.contract, Name:data.filename, type:file.type});
                            this.showAlert(response.data.message);
                            this.loading = false;
                        }
                    })
                    .catch(error =>
                    {
                        this.showAlert(error.response?.data?.message + ' '+  error.response?.data?.errors?.Name, "danger");
                        this.loading = false;
                    });
            },

            removeContract(index, contract) {
                let vm = this;

                if (confirm(this.$t('form.validation.delete'))) {
                    axios
                        .post("/api/professors/contracts/remove", contract)
                        .then(response => {
                            this.showAlert(response.data.message)
                            vm.contracts.splice(index, 1);
                        })
                        .catch(error => {
                            console.log(error.response);
                        });
                }
            },

            /**
             * Upload file error on dropzone
             */
            uploadFileError(file, message) {
                this.showAlert(message.errors, 'danger');
                this.isLoading = false;
            },

            /**
             * Uploaded Attachment Auto-save
             */
            attachmentUploaded(file, data) {
                this.loading = false;
                axios
                    .post("/api/professors/attachment/file/save", {
                        Name: data.filename,
                        File: `${data.id}/${data.filename}`,
                        ProfessorID: this.professor.ID,
                        Description: "",
                        AttachmentDate: this.formatDate(),
                        UploadTimestamp:calculateTimeAsPerTimeZone('+2')
                    })
                    .then(response => {
                        if (response.data)
                        {
                            this.attachments.push({...response.data?.attachment, Name:data.filename, type:file.type});
                            this.showAlert(response.data.message);
                            this.loading = false;
                        }
                    })
                    .catch(error =>
                    {
                        this.showAlert(error.response?.data?.message + ' '+  error.response?.data?.errors?.Name, "danger");
                        this.loading = false;
                    });
            },

            /**
             * Remove attachmemnt from student attachment list
             */
            removeAttachment(index, attach) {
                let vm = this;

                if (confirm(this.$t('form.validation.delete'))) {
                    axios
                        .post("/api/professors/attachments/remove", attach)
                        .then(response => {

                            if (response.data.error) {
                                this.showAlert(response.data.message, 'warning');
                            } else if (response.data.success) {
                                vm.attachments.splice(index, 1);
                                this.showAlert(response.data.message);
                            }

                        })
                        .catch(error => {
                            if (error.response && error.response.status === 403) {
                                this.showAlert(error.response.data.message, "warning");
                            } else {
                                console.log("error", error);
                            }
                        });
                }
            },

            selectProgram(index) {
                if (!this.lectures[index].ProgramID) return;

                this.getProgramCourses(index);
            },

            /**
             * Get Program Related Courses
             */
            getProgramCourses(index) {
                if (index == null) return;

                this.isLoading = true;

                axios
                    .get(`/api/programs/${this.lectures[index].ProgramID}/courses`)
                    .then(response => {
                        this.isLoading = false;

                        this.courses[index] = response.data;
                        this.courses[index].map(c => c.FullTitle = `${c.CourseCode} - ${c.CourseTitle}`);
                    })
                    .catch(error => {
                        this.isLoading = true;
                        console.log('error fetching program related courses')
                    });
            },

            addLecture() {
                this.lectures.push({
                    CourseID: '',
                    ProgramID: '',
                    AcademicYear: '',
                    Term: ''
                });
            },

            removeLecture(index) {
                this.lectures.splice(index, 1);
                this.courses.splice(index, 1);
            },

            saveProfessor(shouldClose = false) {

                if(parseInt(this.professor.MailAddress) == 2)
                    this.$v.$touch();
                else
                    this.$v.professor.$touch();

                if (this.disableEditForm) return;

                this.invalidProfessorCountry = this.professor.Country == null ? true : false;
                this.invalidBussinessCountry = this.professorBusiness.Country == null ? true : false;


                if (this.$v.professor.$invalid)
                {
                    let errorMsg = '';

                    if(this.$v.professor.FirstName.$error){
                            errorMsg = this.$t('form.employee.firstName');
                      }

                     if(this.$v.professor.LastName.$error){
                            errorMsg =  errorMsg ? errorMsg+', '+this.$t('form.employee.lastName'): this.$t('form.employee.lastName');
                      }

                    if(this.$v.professor.BirthPlace.$error){
                            errorMsg = errorMsg ? ', '+ this.$t('form.employee.birthPlace'): this.$t('form.employee.birthPlace');
                      }

                    if(this.$v.professor.BirthDate.$error){
                           errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.birthDate'): this.$t('form.employee.birthDate');
                      }

                    if(this.$v.professor.StreetAddress.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.streetAddress'): this.$t('form.employee.streetAddress');
                      }

                        
                        if(this.$v.professor.City.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.city'): this.$t('form.employee.city');
                      }

                        if(this.$v.professor.Country.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.country'): this.$t('form.employee.country');
                      }

                       if(this.$v.professor.Zip.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.zip'): this.$t('form.employee.zip');
                      }

                    if(this.$v.professor.Mobile.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.mobile'): this.$t('form.employee.mobile');
                      }

                    if(this.$v.professor.Phone.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.phone'): this.$t('form.employee.phone');
                    }

                    if(this.$v.professor.Email.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.email'): this.$t('form.employee.email');
                      }


                    if(this.$v.professorBusiness.CompanyName.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.companyName'): this.$t('form.employee.companyName');
                    }

                    if(this.$v.professorBusiness.Department.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.department'): this.$t('form.employee.department');
                    }

                    if(this.$v.professorBusiness.Position.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.position'): this.$t('form.employee.position');
                    }

                     if(this.$v.professorBusiness.StreetAddress.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.streetAddress'): this.$t('form.employee.streetAddress');
                    }

                    if(this.$v.professorBusiness.City.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.city'): this.$t('form.employee.city');
                    }

                    if(this.$v.professorBusiness.Country.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.country'): this.$t('form.employee.country');
                    }

                     if(this.$v.professorBusiness.Zip.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.zip'): this.$t('form.employee.zip');
                    }
                
                    if(this.$v.professorBusiness.Phone.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.phone'): this.$t('form.employee.phone');
                    }

                     if(this.$v.professorBusiness.Mobile.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.mobile'): this.$t('form.employee.mobile');
                    }
              
                  if(this.$v.professorBusiness.Email.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.email'): this.$t('form.employee.email');
                    }
                    if(this.$v.professorBusiness.ContactPersonFirstName.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.contactPersonFirstName'): this.$t('form.employee.contactPersonFirstName');
                    }
              
                     if(this.$v.professorBusiness.ContactPersonLastName.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.contactPersonLastName'): this.$t('form.employee.contactPersonLastName');
                    }
               
                     if(this.$v.professorBusiness.ContactPersonDepartment.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.contactPersonDepartment'): this.$t('form.employee.contactPersonDepartment');
                    }
               
                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;
                }

                if(parseInt(this.professor.MailAddress) === 2)
                if (this.$v.$invalid)
                {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return;
                }

                let lectures = [];
                let contracts = [];
                let attachments = [];

                this.lectures.forEach(lecture => lectures.push(JSON.stringify(lecture)));
                this.contracts.forEach(contract => contracts.push(JSON.stringify(contract)));
                this.attachments.forEach(attach => attachments.push(JSON.stringify(attach)));

                let data = {
                    professor: JSON.stringify(this.professor),
                    bussiness: JSON.stringify(this.professorBusiness),
                    lectures: lectures,
                    contracts: contracts,
                    attachments: attachments,
                };

                this.isLoading = true;

                axios
                    .put("/api/professors/" + this.$route.params.id, data)
                    .then(response => {
                        this.isLoading = false;
                        this.closing = true;
                        this.updated=true;

                        if (response.data.message) {
                            this.showAlert(response.data.message);
                            if (shouldClose) {
                                clearInterval(this.interval);
                                setTimeout(() => this.$router.go(-1), 2000);
                                return;
                            }
                            /* Update attachments in vue after udating in database*/
                            /* If update only*/
                            this.contracts = [];
                            this.attachments = [];

                            response.data.contracts.forEach(contract =>{
                                let c = contract;
                                c.Name = this.getAttachmentFileName(c.File);
                                c.UploadTimestamp = c.UploadTimestamp ? moment(c.UploadTimestamp).format(this.datetimeFormat) : null
                                this.contracts.push(c);
                            });

                            response.data.attachments.forEach(attach => {
                                let a = attach;
                                a.Name = this.getAttachmentFileName(a.File);
                                a.UploadTimestamp = a.UploadTimestamp ? moment(a.UploadTimestamp).format(this.datetimeFormat) : null
                                this.attachments.push(a);
                            });
                        }

                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error saving professor record.');
                    });
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            async getProfessor() {
                let id = this.$route.params.id;

                if (!id) return;

                this.isLoading = true;

                await axios
                    .get("/api/professors/" + id + '/edit')
                    .then(response => {
                        if (response.data.professor)
                            this.professor = response.data.professor;

                        if (response.data.bussiness)
                            this.professorBusiness = response.data.bussiness;

                        if (this.professor.Photo)
                            this.getImage(`/api/professors/${this.$route.params.id}/profile-image`);

                        // lectures
                        if (response.data.lectures.length > 0) {
                            this.lectures = response.data.lectures;
                            this.lectures.forEach((lecture, index) => this.getProgramCourses(index));
                        }

                        // Contracts
                        if (response.data.contracts.length > 0) {
                            this.contracts = response.data.contracts;
                            this.contracts.map(c => {
                                c.Name = this.getAttachmentFileName(c.File);
                                c.UploadTimestamp = c.UploadTimestamp ? moment(c.UploadTimestamp).format(this.datetimeFormat) : null;
                            });
                        }

                        // Attachments
                        if (response.data.attachments.length > 0) {
                            this.attachments = response.data.attachments;
                            this.attachments.map(c => {
                                c.Name = this.getAttachmentFileName(c.File);
                                c.UploadTimestamp = c.UploadTimestamp ? moment(c.UploadTimestamp).format(this.datetimeFormat) : null;
                            });
                        }

                        this.getAudits();

                        setTimeout(() => {
                            this.isLoading = false;
                            this.closing = true;
                        }, 3000);
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error);
                    });
            },

            getAudits() {
                axios
                    .get(`/api/professors/${this.$route.params.id}/audits`)
                    .then(response => {
                        this.audits = response.data;
                        this.audits.map(audit => {
                            audit.date = audit.createdAt;
                            audit.createdAt = moment(audit.createdAt).format(this.datetimeFormat);
                        });
                    });
            },

            paginateAudits() {
                this.getAudits();
            },



            checkForEdit(refresh = false)
            {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {

                        this.sessionCreated = true;
                        if (response.data.warning == 0) {

                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                                // this.getProfessor();
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },


            // get student profile image
            getImage(url) {
                axios
                    .get(url, {
                        responseType: 'arraybuffer'
                    })
                    .then(response => {
                        this.image = this.imageEncode(response);
                    })
            },

            // encode image to base64
            imageEncode(response) {
                let arrayBuffer = response.data;
                let b64encoded = btoa([].reduce.call(new Uint8Array(arrayBuffer), (p, c) => p + String.fromCharCode(c),
                    ''))
                let mimetype = response.headers['content-type'].toLowerCase()

                return `data:${mimetype};base64,${b64encoded}`
            }
        },

        beforeRouteLeave(to, from, next) {

            clearInterval(this.interval);
            if (this.closing || this.updated) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }
    };

</script>
<style scoped>
    .searchBackground:hover {
        background: #cececf;
    }

    #dropzone,
    #dropzone2 {
        padding: 0;
        margin: 0;
    }

    .custom-validate {
        display: block !important;
    }

</style>
